"use client"
import Link, { LinkProps } from "next/link"
import { useState } from "react"

interface HoverPrefetchLinkProps
  extends Omit<LinkProps, "prefetch" | "onMouseEnter"> {
  children: React.ReactNode
  className?: string
  onMouseEnter?: (e: React.MouseEvent<HTMLAnchorElement>) => void
}

export function HoverPrefetchLink({
  href,
  children,
  onMouseEnter,
  ...restProps
}: HoverPrefetchLinkProps) {
  const [active, setActive] = useState(false)

  const handleMouseEnter = (e: React.MouseEvent<HTMLAnchorElement>) => {
    setActive(true)
    // Call the original onMouseEnter if provided
    onMouseEnter?.(e)
  }

  return (
    <Link
      href={href}
      prefetch={active ? null : false}
      onMouseEnter={handleMouseEnter}
      {...restProps}
    >
      {children}
    </Link>
  )
}
